export class Payment {
  constructor(name, amount) {
    this.name = name;
    this.amount = amount;
  }

  static toInstance(props = {}) {
    return new Payment(props.name, props.amount);
  }

  static toInstanceList(list = []) {
    return list.map(this.toInstance);
  }
}
